import React from 'react';
import { Typography } from '@mui/material';

interface SlideDirectionSelectorProps {
  windowFnValues: any;
  setWindowFnValues: React.Dispatch<React.SetStateAction<any>>;
  chartProp: any;
  propKey: string;
}

const SlideDirectionSelector: React.FC<SlideDirectionSelectorProps> = ({
  windowFnValues,
  setWindowFnValues,
  chartProp,
  propKey,
}) => {
  const isEmptyAxes =
    chartProp.properties[propKey].chartAxes[1].fields.length === 0 ||
    chartProp.properties[propKey].chartAxes[2].fields.length === 0;

  const handleDirectionChange = (direction: 'rowwise' | 'columnwise') => {
    if (windowFnValues.windowFnOptions === 'sliding') {
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        slidingSlideDirection: direction,
      }));
    } else if (windowFnValues.windowFnOptions === 'standingsvssliding') {
      setWindowFnValues((prevState: any) => ({
        ...prevState,
        standingSlidingSlideDirection: direction,
      }));
    }
  };

  return (
    <div>
    <Typography
        sx={{
        fontSize: "12px",
        paddingLeft: "15px",
        fontWeight: "600",
        color: "rgb(96, 96, 96)",
        marginTop: "12px",
        }}
    >
        Slide Direction
    </Typography>

    {isEmptyAxes ? (
        <div className="commonOption2">
        <div
            style={{
            borderRadius: "2px 0 0 2px",
            margin: "3px 0 0 15px",
            color: "rgba(0, 0, 0, 0.38)",
            }}
            className={
            windowFnValues.windowFnOptions === "sliding" &&
            windowFnValues.slidingSlideDirection === "rowwise"
                ? "slideDirectionSelected"
                : windowFnValues.windowFnOptions ===
                    "standingsvssliding" &&
                windowFnValues.standingSlidingSlideDirection ===
                    "rowwise"
                ? "slideDirectionSelected"
                : "slideDirection"
            }
        >
            Row wise
        </div>

        <div
            style={{
            borderRadius: "0 2px 2px 0",
            margin: "3px 15px 0 0",
            color: "rgba(0, 0, 0, 0.38)",
            }}
            className={
            windowFnValues.windowFnOptions === "sliding" &&
            windowFnValues.slidingSlideDirection === "columnwise"
                ? "slideDirectionSelected"
                : windowFnValues.windowFnOptions ===
                    "standingsvssliding" &&
                windowFnValues.standingSlidingSlideDirection ===
                    "columnwise"
                ? "slideDirectionSelected"
                : "slideDirection"
            }
        >
            Column wise
        </div>
        </div>
    ) : (
        <div className="commonOption2">
        <div
            onClick={() => handleDirectionChange('rowwise')}
            style={{
            borderRadius: "2px 0 0 2px",
            margin: "3px 0 0 15px",
            }}
            className={
            windowFnValues.windowFnOptions === "sliding" &&
            windowFnValues.slidingSlideDirection === "rowwise"
                ? "slideDirectionSelected"
                : windowFnValues.windowFnOptions ===
                    "standingsvssliding" &&
                windowFnValues.standingSlidingSlideDirection ===
                    "rowwise"
                ? "slideDirectionSelected"
                : "slideDirection"
            }
        >
            Row wise
        </div>

        <div
            onClick={() => handleDirectionChange('columnwise')}
            style={{
            borderRadius: "0 2px 2px 0",
            margin: "3px 15px 0 0",
            }}
            className={
            windowFnValues.windowFnOptions === "sliding" &&
            windowFnValues.slidingSlideDirection === "columnwise"
                ? "slideDirectionSelected"
                : windowFnValues.windowFnOptions ===
                    "standingsvssliding" &&
                windowFnValues.standingSlidingSlideDirection ===
                    "columnwise"
                ? "slideDirectionSelected"
                : "slideDirection"
            }
        >
            Column wise
        </div>
        </div>
    )}
    </div>
  );
};

export default SlideDirectionSelector;